// extracted by mini-css-extract-plugin
export var checkboxInputRow = "w_sT";
export var checkboxInputColumn = "w_sV";
export var inputOptionRow = "w_qq";
export var inputOptionColumn = "w_qr";